// 健康检查契约。/health 提供存活探针，/ready 检查服务运行所需依赖。
import { z } from 'zod';
export const HealthStatusSchema = z.enum(['ok', 'degraded', 'down']);
/** 四个 required 依赖加 llm；llm 只造成 degraded，不计入 ready。 */
export const DependencyNameSchema = z.enum(['db', 'redis_queue', 'redis_hot', 'minio', 'llm']);
export const DependencyHealthSchema = z.object({
    name: DependencyNameSchema,
    status: HealthStatusSchema,
    required: z.boolean().describe('是否计入 /ready'),
});
export const ReadyViewSchema = z.object({
    status: HealthStatusSchema.describe('任一 required 依赖 down 时为 down；llm degraded 时为 degraded 但 ready=true'),
    ready: z.boolean(),
    dependencies: z.array(DependencyHealthSchema),
});
/** /health（liveness）响应。 */
export const HealthViewSchema = z.object({ status: z.literal('ok') });
/** 计入 /ready 的依赖。外部邮件供应商不影响已有会话与业务请求，因此不在此列。 */
export const REQUIRED_DEPENDENCIES = ['db', 'redis_queue', 'redis_hot', 'minio'];
//# sourceMappingURL=health.js.map